import React from 'react';
import RouteMapper from '../../components/RouteMap';

import ClientToken from './Components/client-token';

{ /* import ServerToken from './Components/server-token'; */ }

export default class Reports extends React.Component {
  render() {
    const { match } = this.props;
    const routes = [
      { path: `${match.url}/client-token`, exact: true, component: ClientToken },
      {/* { path: `${match.url}/server-token`, exact: true, component: ServerToken }, */},
    ];

    return (
      <RouteMapper routes={routes} />
    );
  }
}
